export default "__VITE_ASSET__b01a1893__"